import { render, staticRenderFns } from "./beneficios.vue?vue&type=template&id=21c113b1&scoped=true"
import script from "./beneficios.vue?vue&type=script&lang=js"
export * from "./beneficios.vue?vue&type=script&lang=js"
import style0 from "./beneficios.vue?vue&type=style&index=0&id=21c113b1&prod&scoped=true&lang=css"
import style1 from "./beneficios.vue?vue&type=style&index=1&id=21c113b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c113b1",
  null
  
)

export default component.exports